import React, { Fragment, useState } from 'react';
import {
  hasFutureMovieProgramPlaybackOption,
  hasPastMovieProgramPlaybackOption,
} from '../../../queries/ats/playback/utils';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { ProgramSource } from '../../../queries/ats/titles/types/sources';
import { getPreferredRecording } from '../../../queries/ats/titles/utils/recording-utils';
import { RecordModal } from '../record-modal/record-modal';

interface RecordButtonRenderProps {
  hasRecording: boolean;
  open: () => void;
}

export interface RecordButtonProps {
  asset: Asset;
  source: ProgramSource;
  children: ({ hasRecording, open }: RecordButtonRenderProps) => React.ReactNode;
}

/**
 * For recording task with recording options
 * - Record program
 * - Record all episode, include re-runs
 * - Record current and epsiode after
 * - Auto-delete toggle
 */
export function RecordButton({ asset, source, children }: RecordButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const recording = getPreferredRecording(source, true);
  const hasRecording = recording !== undefined;

  if (asset.type === 'movie') {
    if (hasFutureMovieProgramPlaybackOption(asset)) {
      return (
        <Fragment>
          <RecordModal asset={asset} source={source} isOpen={isOpen} setIsOpen={setIsOpen} />
          {children({ hasRecording, open: () => setIsOpen(true) })}
        </Fragment>
      );
    }
    if (hasPastMovieProgramPlaybackOption(asset)) {
      return null;
    }
  }

  return (
    <Fragment>
      <RecordModal asset={asset} source={source} isOpen={isOpen} setIsOpen={setIsOpen} />
      {children({ hasRecording, open: () => setIsOpen(true) })}
    </Fragment>
  );
}
